import JobTemplate from './JobTemplate';

export default JobTemplate;
